import { useCallback, useState } from "react";
import eventService from "../services/eventService";

export default function useEventManagerController({
  selectedSchoolyear,
  setEvents,
  setSelectedEvent,
  handleCreateEvent,
  handleSaveEvent,
  handleArchiveEvent,
  handleDeleteEvent,
  handleToggleLock,
}) {
  const [errorMessage, setErrorMessage] = useState("");

  const refreshEvents = useCallback(async () => {
    const updated = await eventService.getEvents(selectedSchoolyear.id);
    setEvents(updated);

    if (updated.length > 0) {
      setSelectedEvent(updated[updated.length - 1]);
    }
  }, [selectedSchoolyear, setEvents, setSelectedEvent]);

  const createEventWrapper = async (data, close) => {
    try {
      await handleCreateEvent(data);
      await refreshEvents();
      close();
    } catch {
      setErrorMessage("Event konnte nicht erstellt werden");
    }
  };

  return {
    errorMessage,
    setErrorMessage,
    refreshEvents,
    createEventWrapper,
    handleSaveEvent,
    handleArchiveEvent,
    handleDeleteEvent,
    handleToggleLock,
  };
}
